export function resetRedux() {
  return (dispatch) => {
    return dispatch({type: 'RESET_REDUX', payload: undefined})
  }
}